import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumb-blog',
  templateUrl: './breadcrumb-blog.component.html',
  styleUrls: ['./breadcrumb-blog.component.scss']
})
export class BreadcrumbBlogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
